
export const url = process.env.REACT_APP_SERVER;

